// Make sure to run npm install @formspree/react
// For more help visit https://formspr.ee/react-help
import React, { useEffect, useState } from 'react';
import './styles.css'
import RenderBottom from '../RenderBottom';
import { Box, TextField, Typography, MenuItem } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import StripeView from '../Stripe';
import { useResetProjection } from 'framer-motion';
import emailjs from '@emailjs/browser';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import MuiAlert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';

const theme = createTheme({
  palette: {
    primary: {
      main: '#D05EE1', // 设置主要颜色
    },
    secondary: {
      main: '#dc3545', // 设置次要颜色
    },
    // 更多颜色定义...
  },
});


function ContactForm(fromDialog) {
  const [showSendSuccess, setSendSuccess] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [way, setWay] = useState('搜索引擎');
  const [message, setMessage] = useState('');
  const [wayId, setWayId] = useState(0);

  const [errorName, setErrorName] = useState(false)
  const [errorEmail, setErrorEmail] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const [errorWay, setErrorWay] = useState(false)
  const [loading, setLoading] = useState(false);
  const [isMock, setIsMock] = useState(false); // Mock 开关，true 为模拟模式（不发送邮件）
  const [isSubmitting, setIsSubmitting] = useState(false); // 防重复提交

  useEffect(() => { setErrorWay(!(way.length > 0)) }, [way, wayId]) 


  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const paramWays = [
    { id: 1, textCN: '搜索引擎', textEN: 'search engine' },
    { id: 2, textCN: '学校', textEN: 'university' },
    { id: 3, textCN: '社交媒体 (如小红书)', textEN: 'social media' },
    { id: 4, textCN: '微信公众号', textEN: 'wechat' },
    { id: 5, textCN: '朋友推荐', textEN: 'friend' },
  ];


  const checkEmail = () => {
    const reg = new RegExp(
      '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$',
    );
    setErrorEmail(!(email.match(reg)))
    return email.match(reg);
  };

  const checkName = () => {
    setErrorName(!(name.length > 0))
    return name.length > 0;
  }

  const checkPhone = () => {
    return phone.length >= 0;
  }

  const checkWay = () => {
    setErrorWay(!(way.length > 0 && wayId > 0))
    return way.length > 0 && wayId > 0;
  }

  const checkMessage = () => {

    let totalCharacters = 0;
    
    for (let i = 0; i < message.length; i++) {
        const char = message[i];
        // 使用正则表达式判断字符是否为中文
        if (/[\u4e00-\u9fa5]/.test(char)) {
            totalCharacters += 2; // 中文算作2个字符
        } else {
            totalCharacters += 1; // 数字和字母算作1个字符
        }
    }

    setErrorMessage(!(totalCharacters >= 40))
    return totalCharacters >= 40;

    // setErrorMessage(!(message.length > 20))
    // return message.length > 20;
  }

  const send = () => {
    // 防重复提交：如果正在提交中，直接返回
    if (isSubmitting) {
      console.log('Submission in progress, please wait...');
      return;
    }
    setIsSubmitting(true);

    // return;
    console.log('way', way);

    // Mock 模式：直接显示成功，不发送邮件
    if (isMock) {
      console.log('MOCK MODE: 模拟邮件发送成功');
      setSendSuccess(true);
      setIsSubmitting(false);
      return;
    }

    if (!checkName()) {
      console.log('FAILED...checkName');
      return;
    }

    if (!checkEmail()) {
      console.log('FAILED...checkEmail');
      return;
    }

    if (!checkPhone()) {
      console.log('FAILED...checkPhone');
      return;
    }

    if (!checkWay()) {
      console.log('FAILED...checkWay');
      return;
    }

    if (!checkMessage()) {
      console.log('FAILED...checkMessage');
      return;
    }

    const user_id = 'U-qSOOCZtST1qr_vn';
    const service_id = 'service_1qqe9jt';
    const template_id = 'template_13uf1iq';
    const template_params = {
      'name': name || '',
      'email': email || 'No email',
      'phone': phone || 'No Phone',
      'way': way || 'No Way',
      'message': message || 'No Message',
    };
    setLoading(true);


    emailjs.send(service_id, template_id, template_params, user_id)
      .then(function (response) {
        console.log('SUCCESS!', response.status, response.text);
        setSendSuccess(true)
        //
        setEmail('');
        setPhone('');
        setName('');
        setWay('搜索引擎 search engine');
        setMessage('');
        setWayId(0);
        setLoading(false);
        setIsSubmitting(false);

        //add 添加自动回复给用户 20260308 start
        const template_id2 = 'template_obj1srs';
        const service_id2 = 'service_9vt95ne';
        const template_params2 = {
          'name': name || '',
          'email': email || '297144733@qq.com',
        };
        emailjs.send(service_id2, template_id2, template_params2, user_id).then(function (response) {
          console.log('SUCCESS2!', response.status, response.text);
        }, function (error) {
          console.log('FAILED2...', error);
        });
        //end

      }, function (error) {
        setLoading(false);
        setIsSubmitting(false);
        console.log('FAILED...', error);
      });
  }




  let tempClass = !fromDialog ? 'viewContentWhite' : 'viewContentWhiteDialog';

  console.log('yyy', fromDialog + tempClass);


  return (
    <div className= {'ViewContactFormView'} >
      <div className='viewHeader'>
        <div>
          <div className='textheaderContactus'>
            联系我们
          </div>
        </div>
        <div className='textEN'>
          <div className='textENContact'>Contact</div>
          <div className='textENUs'>Us</div>
        </div>
      </div>
      <div className={tempClass}>
        <div className='SectionName MarginTop20'>
          <div className='sectionLeft'>
            <div className='SectionNameIn'>
              <div className='textName'>称呼</div>
              <div className='textStar'>*</div>
            </div>
            <div className='textNameEN'>Name</div>
          </div>
          <Box
            sx={{
              width: 500,
              maxWidth: '100%',
              height: 50,
            }}
          >
            <ThemeProvider theme={theme}>
              <TextField className='nameTextField' fullWidth id="name"
                // style={{height: '50px', fontSize: '16px'}}
                // variant="filled"
                // size="small"
                value={name}
                onChange={(event) => {
                  setName(event.target.value)
                }}
                color={'primary'}
                maxRows={1}
                type="name"
                name="name"
                error={errorName}
                // helperText={errorName && 'Please enter a valid name.'}
                onBlur={() => {
                  setErrorName(!checkName())
                }}
                // FormHelperTextProps={{ sx: { fontSize: '15px' } }}
                InputLabelProps={{ fontSize: '.2rem' }}
                InputProps={{ sx: { fontSize: '.2rem', height: '.52rem' } }}
                label={
                  <Typography variant="body1" fontSize={'.15rem'} align={'center'} mt={'-.03rem'} >
                    请填写一个您的称呯即可
                  </Typography>
                }
              // sx={{
              //   height: '45px',
              // }}
              />
            </ThemeProvider>
          </Box>
        </div>
        <div className='SectionName MarginTop20'>
          <div className='sectionLeft'>
            <div className='SectionNameIn'>
              <div className='textName'>电子邮件</div>
              <div className='textStar'>*</div>
            </div>
            <div className='textNameEN'>Email Address</div>
          </div>
          <Box
            sx={{
              width: 500,
              maxWidth: '100%',
              height: 50,
            }}
          >
            <ThemeProvider theme={theme}>
              <TextField className='nameTextField' fullWidth id="email"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value)
                }}
                color={'primary'}
                maxRows={1}
                type="email"
                name="email"
                label={
                  <Typography variant="body1" fontSize={'.15rem'} align={'center'} mt={'-.03rem'} >
                    请如实填写，否则无法联系到您
                  </Typography>
                }
                error={errorEmail}
                // helperText={errorEmail && 'Please enter a valid email address.'}
                onBlur={() => {
                  setErrorEmail(!checkEmail())
                }}
                FormHelperTextProps={{ sx: { fontSize: '10px' } }}
                InputLabelProps={{ fontSize: '.2rem' }}
                InputProps={{ sx: { fontSize: '.2rem', height: '.52rem' } }}
              />
            </ThemeProvider>
          </Box>
        </div>
        <div className='SectionName MarginTop20'>
          <div className='sectionLeft'>
            <div className='SectionNameIn'>
              <div className='textName'>联系电话</div>
            </div>
            <div className='textNameEN'>Phone</div>
          </div>
          <Box
            sx={{
              width: 500,
              maxWidth: '100%',
              height: 50,
            }}
          >
            <ThemeProvider theme={theme}>
              <TextField className='nameTextField' fullWidth id="phone"
                // style={{height: '50px', fontSize: '16px'}}
                value={phone}
                onChange={(event) => {
                  setPhone(event.target.value)
                }}
                color={'primary'}
                maxRows={1}
                type="phone"
                name="phone"
                FormHelperTextProps={{ sx: { fontSize: '10px' } }}
                InputLabelProps={{ fontSize: '.2rem' }}
                InputProps={{ sx: { fontSize: '.2rem', height: '.52rem' } }}
                label={
                  <Typography variant="body1" fontSize={'.15rem'} align={'center'} mt={'-.03rem'} >
                    如邮件无法联系到您，会尝试短信联系
                  </Typography>
                }
              />
            </ThemeProvider>
          </Box>
        </div>
        <div className='SectionName MarginTop20 alignStart'>
          <div className='sectionLeft'>
            <div className='SectionNameIn MarginTop10'>
              <div className='textName'>从哪了解到我们</div>
              <div className='textStar'>*</div>
            </div>
            <div className='textNameEN'>Where do you hear about us?</div>
          </div>
          <div className='ways'>
            {
              paramWays.map((item) => (
                <div className='way' onClick={() => { setWayId(item.id); setWay(item?.textCN + item?.textEN); }}>
                  {item.id === wayId ? <div className='pot'></div> : <div className='potUnSelect'></div>}
                  <div className={errorWay ? 'textCN textError' : 'textCN'}>{item?.textCN}</div>
                  <div className={errorWay ? 'textEN textError' : 'textEN'}>{item?.textEN}</div>
                </div>
              ))
            }

          </div>
        </div>
        <div className='SectionName MarginTop20'>
          <div className='sectionLeft'>
            <div className='SectionNameIn'>
              <div className='textName'>您的咨询内容或感兴趣的项目</div>
              <div className='textStar anotherStar'>*</div>
            </div>
            <div className='textNameEN'>Your enquiry</div>
          </div>
          <Box
            sx={{
              width: 500,
              maxWidth: '100%',
              height: 50,
            }}
          >
            <ThemeProvider theme={theme}>
              <TextField className='nameTextField' fullWidth id="message" multiline
                rows={6}
                value={message}
                onChange={(event) => {
                  setMessage(event.target.value)
                }}
                color={'primary'}
                type="message"
                name="message"
                // InputLabelProps={{ fontSize: '10px' }}
                label={
                  <Typography variant="body1" fontSize={'.15rem'} align={'center'} mt={'-.03rem'} >
                    请简单描述您的情况，至少20个字，谢谢
                  </Typography>
                  // <div className='inquiryInputText'>为了更好给予支持，请简单描述您的情况，至少20个字，谢谢</div>
                }
                error={errorMessage}
                // helperText={errorMessage && 'Please enter Your enquiry'}
                onBlur={() => {
                  setErrorMessage(!checkMessage())
                }}
              // FormHelperTextProps={{ sx: { fontSize: '16px' } }}
              />
            </ThemeProvider>
          </Box>
        </div>
        <div className='viewDivContactUs'>
          <div className='viewContactUs' onClick={send}>
            <div className='textContactUs'>Send</div>
          </div>
        </div>
      </div>
      <WXView />
      <Dialog
        open={showSendSuccess}
        onClose={() => { setSendSuccess(false) }}
        PaperProps={{
          sx: { borderRadius: '.3rem', padding: '0px 0px', minWidth: '360px' }
        }}
      >
        {/* <DialogTitle sx={{ textAlign: 'center', fontWeight: 600, fontSize: '18px' }}>
          Your form has been sent, thank you!
        </DialogTitle> */}
        <DialogContent
          sx={{ textAlign: 'center', overflow: 'hidden', width: '5.0rem', padding: '0.3rem 0.3rem 0.3rem 0.3rem'}}
        >
          <MuiAlert severity="success" icon={false} sx={{ flex: 1, justifyContent: 'center', borderRadius: '.3rem', backgroundColor: '#FFF8DE', display: 'block'}}>
            <div style={{ textAlign: 'center' }}>
              <img
                src="https://focus-training.oss-cn-hangzhou.aliyuncs.com/cisc/tips/ciscsendsuccess.png"
                alt="Success"
                style={{ width: '.93rem', height: '.93rem', display: 'block', margin: '0.6rem auto' }}
              />
            </div>
            <div style={{ fontFamily: 'PingFang SC', fontWeight: 600, fontSize: '.28rem', marginTop: '1.2rem', letterSpacing: '0.01rem'}}>已成功发送</div>
            <div style={{ fontFamily: 'PingFang SC', fontWeight: 600, fontSize: '.28rem', letterSpacing: '0.01rem', marginBottom: '0.1rem'}}>Submission Successful</div>
          </MuiAlert>
          <div style={{ marginTop: '.1rem', textAlign: 'left', marginBottom: '.0rem'}}>
            <div style={{ fontFamily: 'PingFang SC', marginTop: '0.38rem', fontSize: '0.22rem', color: '#2E2E2E', lineHeight:'0.36rem', textAlign: 'justify', fontWeight: 400, letterSpacing: '0.01rem'}}>您很快将收到一封确认邮件，其中会包含后续一些相关内容，CISC团队也会与您联系。谢谢！</div>
            <div style={{ fontFamily: 'PingFang SC', marginTop: '0.15rem', fontSize: '0.2rem', color: '#2E2E2E', lineHeight:'0.31rem', textAlign: 'justify', fontWeight: 400}}>You will receive a confirmation email shortly with further details, and the CISC team will also be in touch. Thank you.</div>
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', flexDirection: 'column' }}>
          {/* <Button
            onClick={() => {
              setSendSuccess(false);
              window.location.href = 'https://ciscic.org.uk/assessment';
            }}
            variant="contained"
            style={{ fontSize: '0.2rem', padding: '0.3rem 0.5rem', borderRadius: '.2rem', height: '.4rem' }}
            sx={{ backgroundColor: '#D05EE1', textTransform: 'none', '&:hover': { backgroundColor: '#bf4fc8' } }}
          >
            Assessment
          </Button>
          <Button
            onClick={() => { setSendSuccess(false) }}
            variant="outlined"
            style={{ fontSize: '0.2rem', padding: '0.3rem .5rem', borderRadius: '.2rem', height: '.4rem' }}
            sx={{ borderColor: '#666', color: '#666', textTransform: 'none'}}
          >
            Close
          </Button> */}
          <Button
            onClick={() => {
              setSendSuccess(false);
            }}
            variant="contained"
            style={{ fontFamily: 'PingFang SC', fontSize: '.26rem', fontWeight: 600, padding: '0', borderRadius: '.28rem', width: '1.93rem', height: '.56rem', marginBottom: '.28rem'}}
            sx={{ backgroundColor: '#D05EE1', textTransform: 'none', '&:hover': { backgroundColor: '#D05EE1', boxShadow: '0px 6px 15px 0px rgba(189, 42, 211, 0.38)' }, boxShadow: '0px 6px 15px 0px rgba(189, 42, 211, 0.38)'}}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div >
  );
}

function WXView() {
  return (
    <div className='wxview'>
      <div>
        <div className='text1'>通过微信公众号</div>
        <div className='text1'>
          联系我们
        </div>
      </div>
      <div className='viewqrcode'>
        <img className='qrcode' src="https://focus-training.oss-cn-hangzhou.aliyuncs.com/cisc/qrcodebk.png" />
      </div>
      <div>
        <div className='text2'>关注CISC微信公众号</div>
      </div>
    </div>
  );
}

export default ContactForm;